<template>
  <div class="admintools">
    <v-container>
      <v-row>
        <v-col cols="3" v-for="(item,i) in routes" :key="i" v-show="item.enabled==true" >
          <v-card class="mx-auto" width="100%" outlined>
            <v-card-text>
              <p :title="item.text" >{{item.text}}</p>
            </v-card-text>
            <v-card-actions>
              <v-btn outlined rounded text link @click.stop="$router.push(item.path)" style="width: 100%" >
                <v-icon>{{item.icon}}</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  name : 'Panoramica',
  data() {
    return {
      routes : [
        {text:'Gestione Aziende', path:'/home/amministrazione/gestioneaziende', enabled:false, icon:'mdi-factory'},
        {text:'Gestione Azienda Extra', path:'/home/amministrazione/aziendaextra', enabled:false, icon:'mdi-cog-clockwise'},
        /*{text:'Gestione Moduli', path:'/home/amministrazione/gestionemoduli', enabled:false, icon:'mdi-hexagon-multiple'},
        {text:'Gestione Moduli Aziende', path:'/home/amministrazione/gestionemoduliaziende', enabled:false, icon:'mdi-checkbox-marked-outline'},
        {text:'Gestione Moduli Menu', path:'/home/amministrazione/gestionemodulimenu', enabled:false, icon:'mdi-checkbox-marked-outline'},*/
        {text:'Gestione Profili', path:'/home/amministrazione/gestioneprofili', enabled:false, icon:'mdi-account-star'},
        {text:'Gestione Utenti', path:'/home/amministrazione/gestioneutenti', enabled:false, icon:'mdi-account'},
        {text:'Gestione Permessi', path:'/home/amministrazione/authmenu', enabled:false, icon:'mdi-account-lock'},
        {text:'Gestione Progetti Ticket', path:'/home/amministrazione/progettiticket', enabled:false, icon:'mdi-account-hard-hat'},
        {text:'Gestione Ambiti Aziende Ticket', path:'/home/amministrazione/ambititicket', enabled:false, icon:'mdi-account-details'},
        {text:'Home Layout', path:'/home/amministrazione/GestioneLayout', enabled:false, icon:'mdi-page-layout-header-footer'},
        {text:'Gestione Header e Filtri', path:'/home/amministrazione/gestioneheaderfiltri', enabled:false, icon:'mdi-page-layout-header'},
        {text:'Generazione QR Ospite', path:'/home/amministrazione/qrguest', enabled:false, icon:'mdi-qrcode-edit'},
      ]
    };
  },
  mounted() { 
    const auth_level = localStorage.auth_level;
    if(auth_level == -1){
      for(let i = 0; i < this.routes.length; i++){ this.routes[i].enabled = true; }
    }else{
      for(let i = 0; i < this.routes.length; i++){
        this.routes[i].enabled = (auth_level & (1 << i)) > 0;
      }
    }
  },
};
</script>
<style scoped>
.admintools{
  width:100%;
  position: relative;
  user-select: none;
}
.admintools p{
  white-space: nowrap;
  text-overflow: ellipsis;
  width:100%;
  overflow: hidden;
  font-weight: 500;
  font-size: 18px;
  color:black;
}

</style>